module.exports = __webpack_public_path__ + "static/media/top.57b5a34a.png";